import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import SectionHeading from "./SectionHeading";

const StayInformed = () => {
  return (
    <div className="newsletter_main ">
      <SectionHeading title={"Stay Informed with RXpose !"} />
      <Typography variant="body1" gutterBottom>
        {/* Join our newsletter to receive the latest updates on RXpose, global
        medicine prices, and tips for affordable healthcare. */}
        Subscribe to our newsletter for the latest updates on Rxpose, global medicine prices, and expert healthcare tips.
      </Typography>
      <div className="form_search">
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} sm={8}>
            <input
              type="email"
              placeholder="Enter your email address"
              style={{
                width: "100%",
                padding: "12px 16px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                fontSize: "16px",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button variant="contained" color="primary" fullWidth>
              Subscribe Now
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default StayInformed;
